export const theme = {
  fonts: {
    primaryFont: 'Montserrat',
  },
  fontSizes: {
    xxs: '1.2rem',
    xs: '1.4rem',
    sm: '1.6rem',
    md: '2.1rem',
    lg: '2.4rem',
    xl: '4rem',
  },
  fontWeights: {
    light: 300,
    medium: 500,
    bold: 600,
  },
  colors: {
    primaryWhite: 'hsl(0, 0%, 100%)',
    primaryGrey: 'hsl(204,26%,96%)',
    secondaryGrey: 'hsl(0, 0%, 88%, 0.4)',
    primaryBlue: 'hsl(199, 98%, 48%)',
    secondaryBlue: 'hsl(209, 72%, 47%)',
    thirdaryBlue: 'hsl(	218, 92%, 95%)',
    primaryBlack: 'hsl(0, 0%, 10%, 100%)',
    secondaryBlack: 'hsl(0, 0%, 0%, 40%)',
    primaryRed: 'hsl(4, 90%, 58%, 1)',
    secondaryRed: 'hsl(0, 100%, 40%)	',
    primaryGreen: 'hsl(	123, 41%, 45%)',
    primaryOrange: 'hsl(31, 68%, 46%)',
  },
  responsive: {
    xs: '480px',
    s: '620px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
    xl: `1400px`,
  },
  navHeight: '6.3',
  searchBarHeight: '7',
  zIndex: {
    modal: 9000,
    overlay: 8000,
    dropdown: 7000,
    navigation: 6000,
    below: -1,
  },
};
